export const dummySlaRiskTimes = [
  { id: '1', level: 'Critico', firstResponseValue: 30, firstResponseUnit: 'minutos', resolutionValue: 12, resolutionUnit: 'horas', icon: '😡', color: '#FF4C51' },
  { id: '2', level: 'Alto', firstResponseValue: 2, firstResponseUnit: 'horas', resolutionValue: 24, resolutionUnit: 'horas', icon: '⚠️', color: '#e53e3e' },
  { id: '3', level: 'Medio', firstResponseValue: 4, firstResponseUnit: 'horas', resolutionValue: 48, resolutionUnit: 'horas', icon: '😐', color: '#F1C40F' },
  { id: '4', level: 'Bajo', firstResponseValue: 8, firstResponseUnit: 'horas', resolutionValue: 72, resolutionUnit: 'horas', icon: '🙂', color: '#5DCC0A' },
];

export const dummyCriticalWords = [
  'mala atención',
  'no volveria',
  'grosero',
  'comida mala',
  'sucio',
  'ruido excesivo',
  'demora',
  'incumplimiento'
];

export const dummyAutoAlerts = [
  { id: 'a1', timeWithoutManagement: '12 horas', alertLevel: 'Amarilla', action: 'Notificación al responsable', color: '#F1C40F' },
  { id: 'a2', timeWithoutManagement: '24 horas', alertLevel: 'Roja', action: 'Notificación + Escalar supervisor', color: '#e53e3e' },
  { id: 'a3', timeWithoutManagement: '48 horas', alertLevel: 'Critica', action: 'ESCALAR_A_ADMINISTRACION', color: '#FF4C51' },
];

export interface AlertActionItem {
  label: string;
  value: string;
}

export const ALERT_ACTIONS: AlertActionItem[] = [
  { label: 'Notificación al responsable', value: 'NOTIFICACION_AL_RESPONSABLE' },
  { label: 'Notificación + Escalar supervisor', value: 'NOTIFICACION_ESCALAR_SUPERVISOR' },
  { label: 'Escalar a administración', value: 'ESCALAR_A_ADMINISTRACION' }
];

export const getAlertActionLabel = (value: string): string => {
  const action = ALERT_ACTIONS.find(a => a.value === value);
  return action ? action.label : value;
};
